import { useToast as usePrimeVueToast } from 'primevue/usetoast';
import { useI18n } from 'vue-i18n';

export function useToast() {
  const toast = usePrimeVueToast();
  const { t } = useI18n();

  const createToast = (
    titleText: string,
    content: string,
    type: 'success' | 'warning' | 'danger',
    delay = 5000,
    autoHide = true,
  ) => {
    toast.add({
      severity: getSeverity(type),
      summary: titleText,
      life: autoHide ? delay : undefined,
      detail: content,
    });
  };

  function createSuccessToast(content?: string, delay?: number) {
    createToast(t('generic.success'), content ?? '', 'success', delay);
  }

  function createWarningToast(content?: string, delay?: number) {
    createToast(t('generic.warning'), content ?? '', 'warning', delay);
  }

  function createErrorToast(content?: string, delay?: number) {
    createToast(t('errors.error'), content ?? '', 'danger', delay);
  }

  function getSeverity(type: 'success' | 'warning' | 'danger') {
    switch (type) {
      case 'success':
        return 'success';
      case 'warning':
        return 'warn';
      case 'danger':
        return 'error';
    }
  }

  return {
    createToast,
    createSuccessToast,
    createWarningToast,
    createErrorToast,
  };
}
